import React, { createContext, useContext } from "react"

export interface ContentLayoutContextType {
  scrollableContainerRef: React.RefObject<HTMLDivElement>
}

export const ContentLayoutContext = createContext<
  ContentLayoutContextType | undefined
>(undefined)

function useContentLayoutContext(): ContentLayoutContextType {
  const context = useContext(ContentLayoutContext)
  if (!context) {
    throw new Error(
      "useContentLayoutContext must be used within ContentLayoutProvider",
    )
  }
  return context
}

export default useContentLayoutContext
